export default __webpack_public_path__ + "static/media/treat-yourself-768w.61098965.avif";